<template>
  <div class="home-box">
    <el-breadcrumb class="bread-box" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ routerName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="second-menu-box">
      <div class="box-container">
        <div @click="clickSecondMenu(index, item.id)" :class="secondActiveIndex === String(index) ? 'active-box-item box-item' : 'box-item'" v-for="(item, index) in menuDataList" :key="item.id + index">
          <div v-if="Number(activeIndex) % 5 === 0">
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjianzhuanquan"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjianzhuanquan-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconzizhi"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconzizhi-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconshejishijianzhushi"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconshejishijianzhushi-active"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconshejishijianzhushi"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondesigninpu-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjianzhu"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjianzhu-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjiaoxuechengguo"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjiaoxuechengguo-active-copy"></use>
            </svg>
            <div class="font-menu">{{item.name}}</div>
          </div>
          <div v-if="Number(activeIndex) % 5 === 1">
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondongtai"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondongtai-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconyanfa"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconyanfa-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconquanbuxinwen"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconquanbuxinwen-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjingwuicon_svg_huaban"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconjingwuicon_svg_huaban-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icongongzuotai"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icongongzuotai-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconpingtaiyingyong"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconpingtaiyingyong-active-copy"></use>
            </svg>
            <div class="font-menu">{{item.name}}</div>
          </div>
           <div v-if="Number(activeIndex) % 5 === 2">
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconxinwengonggao"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconxinwengonggao-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icongongzuotai1"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icongongzuotai1-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconqiyelinian"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconqiyelinian-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondesign-preparat"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondesign-preparat-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconhuojiangdengji"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconhuojiangdengji-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconpingtaiyingyong"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconpingtaiyingyong-active-copy"></use>
            </svg>
            <div class="font-menu">{{item.name}}</div>
          </div>
           <div v-if="Number(activeIndex) % 5 === 3">
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconpingtaiguanli1"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconpingtaiguanli1-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconliucheng"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconliucheng-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconhuizhengongzuoliang"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconhuizhengongzuoliang-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconhuanjing"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconhuanjing-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconliuchengguanli"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconliuchengguanli-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconchengguozhuanhua"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconchengguozhuanhua-active-copy"></use>
            </svg>
            <div class="font-menu">{{item.name}}</div>
          </div>
           <div v-if="Number(activeIndex) % 5 === 4">
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondxal"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 0" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icondxal-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconyanfa"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 1" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconyanfa-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconyanfa1"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 2" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconyanfa1-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconchengguo"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 3" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconchengguo-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icon42-jujiao"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 4" class="icon-middle" aria-hidden="true">
              <use xlink:href="#icon42-jujiao-active-copy"></use>
            </svg>
            <svg v-if="secondActiveIndex !== String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconzizhi"></use>
            </svg>
            <svg v-if="secondActiveIndex === String(index) && index % 5 === 5" class="icon-middle" aria-hidden="true">
              <use xlink:href="#iconzizhi-active-copy"></use>
            </svg>
            <div class="font-menu">{{item.name}}</div>
          </div>
        </div>
      </div>
      <el-row v-if="currentType === 2" class="image-box">
        <el-col class="image-item-box" v-for="(item, index) in currentDataImage" :key="item+index" :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
          <img class="image-item" :src="item" />
        </el-col>
      </el-row>
      <el-row v-if="currentType === 1" class="rich-content-box">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <h2 class="title-name">{{currentDataContent.title}}</h2>
          <p class="flex-box">
            <span>来源：{{currentDataContent.source}}</span>
            <span>作者：{{currentDataContent.author}}</span>
            <span>时间：{{currentDataContent.uTime}}</span>
          </p>
          <div class="content-box" v-html="currentDataContent.content" />
        </el-col>
      </el-row>
       <el-row v-if="currentType === 'TABLE_PAGE'" class="article-content-list-box">
         <el-col class="article-item-box" v-for="(item, index) in articleListData" :key="item+index" :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
           <div @click="goArticleContent(item.id)" class="box-list-style">
            <div class="title-box">{{item.title}}</div>
            <div class="box-item-content">{{item.content.replace(/<.*?>/g, "") | dotdot(50)}}</div>
           </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// export function transformType(type) {
//   if (type === 0) return '无样式';
//   if (type === 1) return '富文本';
//   if (type === 2) return '图片列表';
//   if (type === 3) return '图片轮播';
//   if (type === 4) return '富文本卡片';
//   if (type === 5) return '多链接列表';   
//   if (type === 6) return '富文本列表';
//   if (type === 7) return '文字和图';
//   if (type === 8) return '任务职务列表';
// }
import { mapGetters, mapActions } from 'vuex';
import { dotdot } from '../utils/common';
export default {
  name: 'home',
  data() {
    return {
      routerName: this.$route.name,
      activeIndex: this.$route.params.activeIndex || '0',
      firstId: this.$route.params.id,
      menuDataList: [],
      currentType: '',
      currentDataImage: [],
      currentDataContent: '',
      secondActiveIndex: this.$route.params.secondActiveIndex || '0',
      secondId: this.$route.params.secondId,
      articleListData: [],
      articleTotal: 0,
    };
  },
  computed: {
    ...mapGetters(['systemName', 'menuListData', 'baseImageUrl']),
  },
  mounted () {
    console.log(this.activeIndex, this.menuListData, 'this.activeIndex');
    this.initData();
  },
  watch: {
    $route(to,from){
      console.log(to.path, '6666666666666666');
      console.log(this.activeIndex, this.firstId,  this.secondActiveIndex, this.secondId, '66666666666666666======');
      // // this.initData();
      // const firstIndex = to.path.split('/')[2];
      // const firstId = to.path.split('/')[3];
      // const secondIndex = to.path.split('/')[5];
      // const secondId = to.path.split('/')[6];
      // firstId && this.menuIdContent({id: firstId}).then(res => {
      //   if (res.success) {
      //     this.menuDataList = res.data.data;
      //     console.log(res.data, '6666666666666666909099090')
      //     if (res.data.styleType !== -1) {
      //       this.menuIdContent({id: secondId}).then(res => {
      //         console.log(res, '66666666666666666=qqqqqqq')
      //       })

      //     }
      //   }
      // })
    }
  },
  methods: {
    ...mapActions([
      'menuIdContent'
    ]),
    initData () {
      this.menuIdContent({id: this.menuListData[this.activeIndex].id}).then(res => {
        if (res.success) {
          this.menuDataList = res.data.data;
          console.log(this.menuDataList, 'saucxs================6666');
          let firstIdData = this.firstId || this.menuListData[this.activeIndex].id;
          if (this.menuDataList.length > 0 && this.secondId) {
            this.clickSecondMenu(this.secondActiveIndex, this.secondId);
          } else {
            this.clickSecondMenu(this.secondActiveIndex, this.menuDataList[0].id);
          }
          // this.$router.push(`/home/${this.activeIndex}/${firstIdData}/second/0/${this.menuDataList[0].id}`);
        }
      })
    },
    clickSecondMenu(index, secondId) {
      console.log(secondId, 'secondId');
      this.secondActiveIndex = String(index);
      this.$router.push(`/home/${this.activeIndex}/${this.menuListData[this.activeIndex].id}/second/${index}/${secondId}`);
      this.menuIdContent({id: secondId}).then(res => {
        console.log(res, 'saucxs========data');
        if (res.success) {
          this.currentType = res.data.styleType;
          if (this.currentType === 2) {
            this.currentDataImage = res.data.data.length > 0 && res.data.data.map(item => {
              item = this.baseImageUrl + item;
              return item;
            });
          } else if (this.currentType === 1) {
            this.currentDataContent = res.data.data;
          } else if (this.currentType === 'TABLE_PAGE') {
            this.articleListData = res.data.data.records;
            this.articleTotal = res.data.data.total;
          }
        }
      })
    },
    goArticleContent(articleId) {
      this.$router.push(`/article/${this.activeIndex}/${this.firstId}/article/${articleId}`)
    }
  },
};
</script>

<style lang="less" scoped>
.home-box {
  width: 100%;
  .content-box {
    font-size: 0.24rem;
    img {
      width: 100% !important;
    }
  }
  .second-menu-box {
    .box-container {
      display: flex;
      justify-content: flex-start;
      .box-item {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 0.2rem;
        margin: 0 0.2rem 0.2rem 0;
        text-align: center;
        .icon-middle {
          margin: 0 auto;
        }
      }
      .active-box-item {
        text-align: center;
        border-bottom: 2px solid #409EFF;
        color: #409EFF;
      }
      .font-menu {
        font-size: 0.24rem;
        font-weight: bold;
      }
    }
    // 图片列表
    .image-box, .article-content-list-box {
      padding: 0.4rem 0rem;
      .image-item-box {
        padding: 0.14rem;
        // margin: 0 0.2rem 0.2rem 0;
      }
      .article-item-box {

      }
      .image-item {
        width: 100%;
      }
    }
    // 富文本
    .rich-content-box {
      padding: 0.2rem;
    }
    .title-name {
      text-align: center;
      font-size: 0.4rem;
    }
    .flex-box {
      display: flex;
      justify-content: space-around;
      font-size: 0.22rem;
      color: #949494;
    }
    .box-list-style {
      padding: 0.16rem;
      cursor: pointer;
      height: 2rem;
    }
    .title-box {
      font-size: 0.24rem;
      font-weight: bold;
      margin-bottom: 0.2rem;
      color: #409EFF;
    }
    .box-item-content {
      font-size: 0.2rem;
    }
    .box-list-style:hover {
      background: #eee;
      color: #409EFF;
    }
    
  }
}
</style>
